import { useEffect, useMemo, useRef, useState } from "react";
import useOutsideClick from "../../hooks/useOutsideClick";
import { EnquiryMenuProps } from "../../interfaces/menu";
import { EnquiryMenuItems } from ".";

export interface Props extends EnquiryMenuProps {
    x: number;
    y: number;
    onHide: () => void;
}

export function EnquiryContextMenu(props: Props) {
    const menuRef = useRef<HTMLDivElement>(null);
    useOutsideClick(menuRef, props.onHide);
    const rightPane = document.getElementById("rightPane");
    const x =
        rightPane != null
            ? props.x + 195 > rightPane.clientWidth
                ? props.x - 195
                : props.x
            : props.x + 195 > window.innerWidth
              ? props.x - 195
              : props.x;
    const y = props.y + 218 > window.innerHeight ? props.y - 218 : props.y;

    return (
        <div
            ref={menuRef}
            style={{ position: "absolute", top: y, left: x }}
        >
            <EnquiryMenuItems
                onHide={props.onHide}
                enquiryIds={props.enquiryIds}
            />
        </div>
    );
}
